import type { HandlerFunction } from "../types";
import { useRequirementsStore } from "~/stores/requirements";
import { useTrainingStore } from "~/stores/training";
import { useSupervisionStore } from "~/stores/supervision";

/**
 * Manager message handler
 *
 * Handles manager-specific SSE events including:
 * - Approval requests
 * - Team updates
 * - Report readiness notifications
 * - HR: Requirements, Trainings, Supervisions
 */
export const handleManagerMessage: HandlerFunction = (data: {
  type: string;
  message?: string;
  staffReq?: any;
  training?: any;
  supervision?: any;
}) => {
  const toast = useToast();

  switch (data.type) {
    case "approval_request":
      break;

    case "team_update":
      toast.add({
        title: "Team Updated",
        description: data.message,
        color: "indigo",
        icon: "i-heroicons-user-group",
        duration: 5000,
      });
      break;

    case "report_ready":
      break;

    // HR: Requirements
    case "requirement.submitted":
    case "requirement.reviewed":
    case "requirement.deleted": {
      const requirementsStore = useRequirementsStore();
      if (data.type === "requirement.deleted") {
        requirementsStore.removeStaffReqLocal(data.staffReq.id);
      } else if (data.type === "requirement.submitted") {
        requirementsStore.addStaffReqLocal(data.staffReq);
      } else {
        requirementsStore.updateStaffReqLocal(data.staffReq);
      }
      requirementsStore.refreshStats();
      break;
    }

    // HR: Trainings
    case "training.created":
    case "training.updated":
    case "training.verified":
    case "training.deleted": {
      const trainingStore = useTrainingStore();
      if (data.type === "training.deleted") {
        trainingStore.removeManagerTrainingLocal(data.training.id);
      } else {
        trainingStore.addOrUpdateManagerTrainingLocal(data.training);
      }
      break;
    }

    // HR: Supervisions
    case "supervision.created":
    case "supervision.updated":
    case "supervision.signed":
    case "supervision.rejected":
    case "supervision.deleted": {
      const supervisionStore = useSupervisionStore();
      if (data.type === "supervision.deleted") {
        supervisionStore.removeManagerSupervisionLocal(data.supervision.id);
      } else {
        supervisionStore.addOrUpdateManagerSupervisionLocal(data.supervision);
      }
      break;
    }

    default:
      console.log("Unknown manager message type:", data.type);
  }
};
